var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 147,
    viewBox: "0 0 177 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53615 42H6.46385C4.55873 42 3 43.575 3 45.5C3 47.425 4.55873 49 6.46385 49H8.53615C10.4413 49 12 47.425 12 45.5C12 43.575 10.4413 42 8.53615 42Z",
    fill: "#F1F2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.5 113C128.575 113 127 111.425 127 109.5C127 107.575 128.575 106 130.5 106C132.425 106 134 107.575 134 109.5C134 111.425 132.425 113 130.5 113Z",
    fill: "#E1E3EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92285 67.5V69",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55371 68.3125L3.77943 69.5743",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12012 71.6714H2.85326",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41309 75.0899L3.6388 73.8281",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92285 75.5V74",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42285 74.5L7.42285 73.5",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4229 72H8.92285",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42285 68.5L8.42285 69.5",
    stroke: "#D2D8DF",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4229 2V3",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4229 5H84.4229",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4229 8V7",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9229 5H87.9229",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4229 44V45.5",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9229 48.5H25.4229",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4229 52.5V51",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4229 48.5H30.9229",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.05 98.5195C137.245 98.5195 138.214 99.4889 138.214 100.684C138.214 101.88 137.245 102.849 136.05 102.849C134.855 102.849 133.886 101.88 133.886 100.684",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.953 78.8817C147.238 78.4809 149.208 76.9095 149.663 75.2188C150.077 76.7133 151.81 78.4809 153.374 78.6146C151.614 79.2379 149.93 81.0896 149.663 82.5442C149.482 81.0615 147.154 79.0978 145.953 78.8817Z",
    fill: "#EBECEE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0586 97.8527C14.7013 97.6523 15.6856 96.8668 15.9136 96.0215C16.1203 96.7683 16.9867 97.6523 17.7685 97.7194C16.8886 98.0306 16.0473 98.9567 15.9136 99.684C15.8227 98.9427 14.6588 97.9606 14.0586 97.8527Z",
    fill: "#EBECEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9848 28.2985C25.9848 29.2258 25.2335 29.9769 24.3069 29.9769C23.3798 29.9769 22.6289 29.2258 22.6289 28.2985C22.6289 27.3716 23.3798 26.6201 24.3069 26.6201C25.2335 26.6201 25.9848 27.3716 25.9848 28.2985Z",
    fill: "#D1D8DF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.032 32.8053C138.032 34.3546 136.776 35.6105 135.228 35.6105C133.678 35.6105 132.423 34.3546 132.423 32.8053C132.423 31.2559 133.678 30 135.228 30C136.776 30 138.032 31.2559 138.032 32.8053Z",
    fill: "#EBECEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.88 25.2048C176.88 26.434 175.884 27.43 174.655 27.43C173.426 27.43 172.431 26.434 172.431 25.2048C172.431 23.9756 173.426 22.9795 174.655 22.9795C175.884 22.9795 176.88 23.9756 176.88 25.2048Z",
    fill: "#EBECEE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3446 129.134C57.3446 129.909 56.7168 130.537 55.9421 130.537C55.1678 130.537 54.54 129.909 54.54 129.134C54.54 128.359 55.1678 127.731 55.9421 127.731C56.7168 127.731 57.3446 128.359 57.3446 129.134Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5102 17.5158C56.5102 18.4431 55.7589 19.1942 54.8323 19.1942C53.9056 19.1942 53.1543 18.4431 53.1543 17.5158C53.1543 16.5889 53.9056 15.8374 54.8323 15.8374C55.7589 15.8374 56.5102 16.5889 56.5102 17.5158Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3116 144.668C98.2394 145.076 97.0394 144.537 96.6315 143.465C96.2235 142.393 96.7618 141.192 97.8344 140.784C98.9062 140.376 100.106 140.915 100.514 141.987C100.923 143.06 100.384 144.26 99.3116 144.668Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6725 105H57.6701C54.7842 105 52.4219 102.631 52.4219 99.7351V41.2637C52.4219 38.3681 54.7842 36 57.6701 36H98.6725C101.56 36 103.922 38.3681 103.922 41.2637V99.7351C103.922 102.631 101.56 105 98.6725 105Z",
    fill: "#E0E2EE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1725 107.5H54.1701C51.2842 107.5 48.9219 105.131 48.9219 102.235V43.7637C48.9219 40.8681 51.2842 38.5 54.1701 38.5H95.1725C98.0596 38.5 100.422 40.8681 100.422 43.7637V102.235C100.422 105.131 98.0596 107.5 95.1725 107.5Z",
    fill: "#E8EBF2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7681 109.474H50.681C47.7891 109.474 45.4219 107.114 45.4219 104.23V46.0012C45.4219 43.1176 47.7891 40.7593 50.681 40.7593H91.7681C94.6612 40.7593 97.0283 43.1176 97.0283 46.0012V104.23C97.0283 107.114 94.6612 109.474 91.7681 109.474Z",
    fill: "#D8DBEA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7681 109.474H50.681C47.7891 109.474 45.4219 107.114 45.4219 104.23V46.0012C45.4219 43.1176 47.7891 40.7593 50.681 40.7593H91.7681C94.6612 40.7593 97.0283 43.1176 97.0283 46.0012V104.23C97.0283 107.114 94.6612 109.474 91.7681 109.474Z",
    fill: "#F1F2F7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8458 58.5H55.498C54.6313 58.5 53.9219 57.8251 53.9219 57.0006C53.9219 56.1749 54.6313 55.5 55.498 55.5H85.8458C86.7125 55.5 87.4219 56.1749 87.4219 57.0006C87.4219 57.8251 86.7125 58.5 85.8458 58.5Z",
    fill: "#E0E2EE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8458 67.5H55.498C54.6313 67.5 53.9219 66.8251 53.9219 66.0006C53.9219 65.1749 54.6313 64.5 55.498 64.5H85.8458C86.7125 64.5 87.4219 65.1749 87.4219 66.0006C87.4219 66.8251 86.7125 67.5 85.8458 67.5Z",
    fill: "#E0E2EE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8458 76.5H55.498C54.6313 76.5 53.9219 75.8251 53.9219 75.0006C53.9219 74.176 54.6313 73.5 55.498 73.5H85.8458C86.7125 73.5 87.4219 74.176 87.4219 75.0006C87.4219 75.8251 86.7125 76.5 85.8458 76.5Z",
    fill: "#E0E2EE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8458 85.5H55.498C54.6313 85.5 53.9219 84.8251 53.9219 84.0006C53.9219 83.1749 54.6313 82.5 55.498 82.5H85.8458C86.7125 82.5 87.4219 83.1749 87.4219 84.0006C87.4219 84.8251 86.7125 85.5 85.8458 85.5Z",
    fill: "#E0E2EE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.339 94.5H55.5047C54.6343 94.5 53.9219 93.8251 53.9219 93.0006C53.9219 92.1749 54.6343 91.5 55.5047 91.5H71.339C72.2094 91.5 72.9219 92.1749 72.9219 93.0006C72.9219 93.8251 72.2094 94.5 71.339 94.5Z",
    fill: "#E0E2EE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.299 82.8684C97.231 88.9357 87.8365 89.6202 81.0161 84.9358C80.1444 84.3264 79.3148 83.6419 78.5411 82.8684C78.1429 82.4714 77.7675 82.0618 77.4137 81.6305C76.7063 80.7692 76.0866 79.8506 75.5789 78.9015C74.6843 77.2985 74.0761 75.5975 73.744 73.8393C72.6726 68.3254 74.2746 62.3904 78.5411 58.1258C82.8179 53.8486 88.7539 52.257 94.2687 53.3181C96.026 53.6603 97.7285 54.2684 99.3318 55.1526C100.282 55.6717 101.188 56.2913 102.051 56.9986C102.481 57.3511 102.891 57.7276 103.288 58.1258C104.063 58.8994 104.758 59.7276 105.356 60.6004C110.042 67.4183 109.356 76.8125 103.299 82.8684Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.601 81.6734C95.288 87.9879 85.0568 87.9867 78.7423 81.6734C72.4361 75.3672 72.4361 65.1348 78.7506 58.8215C85.0568 52.5152 95.288 52.5152 101.594 58.8215C107.908 65.1348 107.908 75.3672 101.601 81.6734ZM104.841 55.5778C96.7377 47.4741 83.6059 47.4741 75.5023 55.5778C67.3998 63.6803 67.3927 76.8202 75.4952 84.9239C82.8705 92.2969 94.4304 92.9618 102.561 86.9081C103.355 86.316 104.12 85.6523 104.85 84.9239C105.578 84.1944 106.242 83.4296 106.833 82.6354C112.886 74.5036 112.215 62.9519 104.841 55.5778Z",
    fill: "#A9A9A9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.733 115.471L136.393 115.811C134.142 118.063 130.456 118.063 128.204 115.811L107.422 95.0287L115.951 86.5L136.733 107.282C138.985 109.534 138.985 113.219 136.733 115.471Z",
    fill: "url(#paint0_linear_117_6850)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.281 82L113.422 88.1413L109.062 92.5L102.922 86.3587C103.732 85.7545 104.511 85.0772 105.257 84.334C106 83.5908 106.678 82.8104 107.281 82Z",
    fill: "#A9A9A9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.422 107.027L127.948 115.5L126.422 113.973L134.895 105.5L136.422 107.027Z",
    fill: "#EF545F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.422 86.7934L107.715 95.5L106.422 94.2066L115.128 85.5L116.422 86.7934Z",
    fill: "#FF9E6E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4219 56.6493L76.0701 78C75.266 76.5589 74.7193 75.0296 74.4219 73.449L92.8706 55C94.4502 55.3088 95.9807 55.8544 97.4219 56.6493Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.422 61.7242L81.3383 83.5C80.5117 82.9558 79.7248 82.3433 78.9911 81.6511C78.6134 81.2948 78.2562 80.9293 77.9219 80.5434L101.287 58.5C101.696 58.8165 102.084 59.1535 102.461 59.5098C103.195 60.202 103.855 60.9432 104.422 61.7242Z",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_6850",
    x1: 107.422,
    y1: 102,
    x2: 138.422,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.1f8bb95e38501d0f2f56d3ee5f51c79d.svg";
export { ForwardRef as ReactComponent };